import React from 'react'
import { useTranslation } from 'react-i18next'
import styles from './CheckOutForm.module.css'
import BillingAddressWrapper from '../BillingAddressWrapper/BillingAddressWrapper'
import ShippingAddressWrapper from '../ShippingAddressWrapper/ShippingAddressWrapper'
import { useSelector } from 'react-redux'

function CheckOutForm({
  data,
  handleChange,
  errors,
  showAddress,
  setShowAddress,
  shippingPrices // 👈 جديد
}) {
  const { t } = useTranslation()
const selector = useSelector(state=>state?.GlobalReducer)

  return (
    <section className={styles['show-address']}>

      {/* Billing Address */}
      <BillingAddressWrapper
        data={data}
        handleChange={handleChange}
        errors={errors}
        shippingPrices={selector?.settings?.shipping_prices}
      />

      {/* Toggle Shipping Address */}
      <div className={styles['show-address__wrapper']}>
        <input
          type='checkbox'
          className={styles['show-address__input']}
          id='showAddress'
          checked={showAddress}
          onChange={() => setShowAddress(prev => !prev)}
        />
        <label
          htmlFor='showAddress'
          className={styles['show-address__label']}
        >
          {t('Ship to a different address?')}
        </label>
      </div>

      {/* Shipping Address */}
      {showAddress && (
        <ShippingAddressWrapper
          data={data}
          handleChange={handleChange}
          errors={errors}
          shippingPrices={shippingPrices}
        />
      )}

    </section>
  )
}

export default CheckOutForm
